import { apiPost } from '../api';
import { ApiNames, ApiPath } from '../enums';

export async function terminateUser(): Promise<void> {
  await apiPost(ApiNames.MonorepoApiEndpoint, ApiPath.TerminateAccount, {}, true);
}
